import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function CommunitiesStrip() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/communities").then(({ data }) => { if (alive) setItems(data.communities || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!items.length) return null;

  return (
    <section className="mt-5" data-testid="explore-communities-strip">
      <div className="flex items-center justify-between px-5 mb-3">
        <p className="text-cream/60 text-xs tracking-[0.2em] uppercase font-bold">Communities</p>
        <Link to="/communities" data-testid="explore-communities-all" className="text-papaya text-[11px] font-black tracking-[0.15em] uppercase">See all</Link>
      </div>
      <div className="flex gap-3 overflow-x-auto no-scrollbar px-5 pb-1">
        {items.map((c) => (
          <Link
            key={c.slug}
            to={`/c/${c.slug}`}
            data-testid={`explore-community-${c.slug}`}
            className="relative shrink-0 w-36 h-24 rounded-2xl overflow-hidden border border-white/10 hover:border-papaya/60 transition-colors"
          >
            <img src={c.cover} alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-2">
              <p className="text-cream text-xs font-black leading-tight">{c.emoji} {c.name}</p>
              <p className="text-cream/60 text-[10px]">{(c.post_count || 0).toLocaleString()} posts</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
